import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Card } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import defaultImg from './../assets/images/default.png'
import NoResult from './../components/NoResult'
import LoadingScreen from '../components/LoadingScreen/LoadingScreen';

export default function GetServiceProvider() {
    const [data, setData] = useState([]);
    const PF = process.env.REACT_APP_FIND_API_URL + "/images/";
    const { user } = useSelector((state) => state.auth);
    const sellerId = user.seller_profile_id;

    const [isLoading, setIsLoading] = useState(true);
    const DELAY_TIME = 1500;
    useEffect(() => {
        const pageTimeout = setTimeout(() => {
            axios.post(process.env.REACT_APP_FIND_API_URL + '/serviceProvider-services/get-serviceProviderServices/' + sellerId, {}, { withCredentials: true })
                .then((res) => {
                    setData(res.data.data);
                    setIsLoading(false)
                }).catch((err) => {
                    setIsLoading(false);
                    console.log(err);
                })
        }, DELAY_TIME)
        return () => {
            clearTimeout(pageTimeout);
        }
    }, [sellerId])
    return (
        <>
            {
                isLoading ? (
                    <LoadingScreen />
                ) : !data[0] ?
                    <NoResult name="Add Services/Stores" link={'/sell-on-findNow'} />
                    : (<>
                        {
                            data.map((data) => (
                                <Card>
                                    <Card.Img variant="top" height="300" src={data.service_provider_display_images === null ? defaultImg : PF + data.service_provider_display_images} />
                                    <Card.Body>
                                        <Card.Text>
                                            <h2>Name: {data.service_name}</h2>
                                            <span>Address: {data.service_provider_address}</span>
                                            <p>Charges: {data.service_charges}</p>
                                            <h3>Speciality: {data.service_speciality}</h3>
                                            <b>Timings: {data.service_timings}</b>
                                            <br />
                                            <h1 className='text-center my-4'>Profile Info</h1>
                                            <p>Email: {data.service_provider_email}</p>
                                            <p>Number: {data.service_provider_number}</p>
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            ))
                        }
                    </>
                    )
            }
        </>
    )
}